// extracted by mini-css-extract-plugin
export default {"btn_home":"style_btn_home__qsv4B"};